export const RELATION_TYPES = {
  RELATES: 'relates',
  BLOCKS: 'blocks',
  BLOCKED_BY: 'blocked_by',
};

export const RELATION_ENTITY_TYPES = {
  TICKET: 'ticket',
  TASK: 'task',
  ORDER: 'order',
};

export const RELATION_CONFIG = {
  [RELATION_TYPES.RELATES]: {
    relation: 'Связана с',
    entity: {
      [RELATION_ENTITY_TYPES.TASK]: 'задачей',
      [RELATION_ENTITY_TYPES.TICKET]: 'тикетом',
      [RELATION_ENTITY_TYPES.ORDER]: 'заказом',
    },
  },
  [RELATION_TYPES.BLOCKS]: {
    relation: 'Блокирует',
    entity: {
      [RELATION_ENTITY_TYPES.TASK]: 'задачу',
      [RELATION_ENTITY_TYPES.TICKET]: 'тикет',
      [RELATION_ENTITY_TYPES.ORDER]: 'заказ',
    },
  },
  [RELATION_TYPES.BLOCKED_BY]: {
    relation: 'Заблокирована',
    entity: {
      [RELATION_ENTITY_TYPES.TASK]: 'задачей',
      [RELATION_ENTITY_TYPES.TICKET]: 'тикетом',
      [RELATION_ENTITY_TYPES.ORDER]: 'заказом',
    },
  },
};

export const RELATION_ENTITY_BY_TYPE = {
  [RELATION_ENTITY_TYPES.TICKET]: 'Связанные тикеты',
  [RELATION_ENTITY_TYPES.TASK]: 'Связанные задачи',
  [RELATION_ENTITY_TYPES.ORDER]: 'Связанные заказы',
};
